import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.inviteModel.error}}
  <div class="alert alert-error">
    {{html-safe this.errorMessage}}
  </div>
{{/if}}

<div class="body">
  {{#if this.inviteModel.finished}}
    {{#if this.inviteModel.inviteLink}}
      <GeneratedInviteLink
        @link={{this.inviteModel.inviteLink}}
        @email={{this.invitee}}
      />
    {{else}}
      <div class="success-message">
        {{html-safe this.successMessage}}
      </div>
    {{/if}}
  {{else}}
    <div class="invite-user-control">
      <label class="instructions">{{this.inviteInstructions}}</label>
      <div class="invite-user-input-wrapper">
        {{#if this.allowExistingMembers}}
          <EmailGroupUserChooser
            @value={{this.invitee}}
            @onChange={{action "updateInvitee"}}
            @options={{hash
              maximum=1
              allowEmails=this.canInviteViaEmail
              excludeCurrentUser=true
              includeMessageableGroups=this.isPM
              filterPlaceholder=this.placeholderKey
              fullWidthWrap=true
            }}
            class="invite-user-input"
          />
        {{else}}
          <TextField
            @value={{this.invitee}}
            @placeholderKey="topic.invite_reply.email_placeholder"
            class="email-or-username-input"
          />
        {{/if}}
        {{#if this.capabilities.hasContactPicker}}
          <DButton
            @icon="address-book"
            @action={{this.searchContact}}
            class="btn-primary open-contact-picker"
          />
        {{/if}}
      </div>
    </div>

    {{#if this.showGroups}}
      <div class="group-access-control">
        <label class="instructions {{this.showGroupsClass}}">
          {{i18n "topic.automatically_add_to_groups"}}
        </label>
        <GroupChooser
          @content={{this.allGroups}}
          @value={{this.groupIds}}
          @labelProperty="name"
          @onChange={{fn (mut this.groupIds)}}
        />
      </div>
    {{/if}}

    {{#if this.showCustomMessage}}
      <div class="show-custom-message-control">
        <label class="instructions">
          <DiscourseLinkedText
            @action={{action "showCustomMessageBox"}}
            @text="invite.custom_message"
            class="optional"
          />
        </label>
        {{#if this.hasCustomMessage}}
          <Textarea
            @value={{this.customMessage}}
            placeholder={{this.customMessagePlaceholder}}
          />
        {{/if}}
      </div>
    {{/if}}
  {{/if}}

  {{#if this.showApprovalMessage}}
    <label class="instructions approval-notice">
      {{i18n "invite.approval_not_required"}}
    </label>
  {{/if}}
</div>

<div class="footer">
  {{#if this.inviteModel.finished}}
    <DButton @action={{@closeModal}} @label="close" class="btn-primary" />
  {{else}}
    <DButton
      @icon={{this.inviteIcon}}
      @action={{this.createInvite}}
      @disabled={{this.disabled}}
      @label={{this.buttonTitle}}
      class="btn-primary send-invite"
    />
    {{#if this.showCopyInviteButton}}
      <DButton
        @icon="link"
        @action={{this.generateInviteLink}}
        @disabled={{this.disabledCopyLink}}
        @label="user.invited.generate_link"
        class="btn-primary generate-invite-link"
      />
    {{/if}}
  {{/if}}
</div>
*/
{
  "id": "YkGxQOzP",
  "block": "[[[41,[30,0,[\"inviteModel\",\"error\"]],[[[1,\"  \"],[10,0],[14,0,\"alert alert-error\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[[30,0,[\"errorMessage\"]]],null]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,0],[14,0,\"body\"],[12],[1,\"\\n\"],[41,[30,0,[\"inviteModel\",\"finished\"]],[[[41,[30,0,[\"inviteModel\",\"inviteLink\"]],[[[1,\"      \"],[8,[39,2],null,[[\"@link\",\"@email\"],[[30,0,[\"inviteModel\",\"inviteLink\"]],[30,0,[\"invitee\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"success-message\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[[30,0,[\"successMessage\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]]]],[]],[[[1,\"    \"],[10,0],[14,0,\"invite-user-control\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"instructions\"],[12],[1,[30,0,[\"inviteInstructions\"]]],[13],[1,\"\\n      \"],[10,0],[14,0,\"invite-user-input-wrapper\"],[12],[1,\"\\n\"],[41,[30,0,[\"allowExistingMembers\"]],[[[1,\"          \"],[8,[39,3],[[24,0,\"invite-user-input\"]],[[\"@value\",\"@onChange\",\"@options\"],[[30,0,[\"invitee\"]],[28,[37,4],[[30,0],\"updateInvitee\"],null],[28,[37,5],null,[[\"maximum\",\"allowEmails\",\"excludeCurrentUser\",\"includeMessageableGroups\",\"filterPlaceholder\",\"fullWidthWrap\"],[1,[30,0,[\"canInviteViaEmail\"]],true,[30,0,[\"isPM\"]],[30,0,[\"placeholderKey\"]],true]]]]],null],[1,\"\\n\"]],[]],[[[1,\"          \"],[8,[39,6],[[24,0,\"email-or-username-input\"]],[[\"@value\",\"@placeholderKey\"],[[30,0,[\"invitee\"]],\"topic.invite_reply.email_placeholder\"]],null],[1,\"\\n\"]],[]]],[41,[30,0,[\"capabilities\",\"hasContactPicker\"]],[[[1,\"          \"],[8,[39,7],[[24,0,\"btn-primary open-contact-picker\"]],[[\"@icon\",\"@action\"],[\"address-book\",[30,0,[\"searchContact\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showGroups\"]],[[[1,\"      \"],[10,0],[14,0,\"group-access-control\"],[12],[1,\"\\n        \"],[10,\"label\"],[15,0,[29,[\"instructions \",[30,0,[\"showGroupsClass\"]]]]],[12],[1,\"\\n          \"],[1,[28,[35,8],[\"topic.automatically_add_to_groups\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,9],null,[[\"@content\",\"@value\",\"@labelProperty\",\"@onChange\"],[[30,0,[\"allGroups\"]],[30,0,[\"groupIds\"]],\"name\",[28,[37,10],[[28,[37,11],[[30,0,[\"groupIds\"]]],null]],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showCustomMessage\"]],[[[1,\"      \"],[10,0],[14,0,\"show-custom-message-control\"],[12],[1,\"\\n        \"],[10,\"label\"],[14,0,\"instructions\"],[12],[1,\"\\n          \"],[8,[39,12],[[24,0,\"optional\"]],[[\"@action\",\"@text\"],[[28,[37,4],[[30,0],\"showCustomMessageBox\"],null],\"invite.custom_message\"]],null],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"hasCustomMessage\"]],[[[1,\"          \"],[8,[39,13],[[16,\"placeholder\",[30,0,[\"customMessagePlaceholder\"]]]],[[\"@value\"],[[30,0,[\"customMessage\"]]]],null],[1,\"\"]],[]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null]],[]]],[1,\"\\n\"],[41,[30,0,[\"showApprovalMessage\"]],[[[1,\"    \"],[10,\"label\"],[14,0,\"instructions approval-notice\"],[12],[1,\"\\n      \"],[1,[28,[35,8],[\"invite.approval_not_required\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"footer\"],[12],[1,\"\\n\"],[41,[30,0,[\"inviteModel\",\"finished\"]],[[[1,\"    \"],[8,[39,7],[[24,0,\"btn-primary\"]],[[\"@action\",\"@label\"],[[30,1],\"close\"]],null],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,7],[[24,0,\"btn-primary send-invite\"]],[[\"@icon\",\"@action\",\"@disabled\",\"@label\"],[[30,0,[\"inviteIcon\"]],[30,0,[\"createInvite\"]],[30,0,[\"disabled\"]],[30,0,[\"buttonTitle\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"showCopyInviteButton\"]],[[[1,\"      \"],[8,[39,7],[[24,0,\"btn-primary generate-invite-link\"]],[[\"@icon\",\"@action\",\"@disabled\",\"@label\"],[\"link\",[30,0,[\"generateInviteLink\"]],[30,0,[\"disabledCopyLink\"]],\"user.invited.generate_link\"]],null],[1,\"\\n\"]],[]],null]],[]]],[13]],[\"@closeModal\"],false,[\"if\",\"html-safe\",\"generated-invite-link\",\"email-group-user-chooser\",\"action\",\"hash\",\"text-field\",\"d-button\",\"i18n\",\"group-chooser\",\"fn\",\"mut\",\"discourse-linked-text\",\"textarea\"]]",
  "moduleName": "discourse/components/invite-panel.hbs",
  "isStrictMode": false
});